module.exports = __webpack_public_path__ + "static/apple_music_logo-ff924ef641df37c24cba749cf392a970.png";